import type * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { aPIKeyQuerySchema } from './api-key-query-schema';
import { environmentFormSchema } from './environment-schema';

export const aPIKeyFormSchema = aPIKeyQuerySchema
  .omit({
    created_by_id: true,
    last_updated_by_id: true,
  })
  .extend({
    status: statusFormSchema,
    environment: environmentFormSchema,
  });

export type APIKeyFormSchema = z.infer<typeof aPIKeyFormSchema>;
